import { Globe, Scan, BarChart3, Wrench } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const steps = [
  {
    icon: Globe,
    number: '01',
    title: 'Enter URL or Domain',
    description: 'Start with a quick page check or switch to Domain Analysis for sitemap-driven site-wide execution.',
  },
  {
    icon: Scan,
    number: '02',
    title: 'Discover & Plan',
    description: 'We discover URLs from domain resources, group templates, and help you choose All, Auto, or Manual sampling.',
  },
  {
    icon: BarChart3,
    number: '03',
    title: 'Run in Background',
    description: 'Approve once and process asynchronously with progress tracking, pause/resume controls, and crash recovery.',
  },
  {
    icon: Wrench,
    number: '04',
    title: 'Ship Fixes Faster',
    description: 'Use master + child reports to prioritize fixes and improve visibility across search engines and AI assistants.',
  },
];

const HowItWorks = () => (
  <section id="how-it-works" className="py-20 md:py-24 bg-white">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-cv-sky/10 text-cv-navy text-xs font-bold uppercase tracking-wider rounded-full border border-cv-sky/30 mb-4">
            How It Works
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-cv-navy mb-4">
            From Single URL to Domain-Wide Decisions in <span className="text-cv-navy">One Workflow</span>
          </h2>
          <p className="text-cv-navy/70 max-w-2xl mx-auto text-lg">
            A unified path for tactical page audits and strategic domain analysis at scale.
          </p>
        </div>
      </ScrollReveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-4">
        {steps.map((step, i) => (
          <ScrollReveal key={step.number} delay={i * 0.12}>
            <div className="relative flex flex-col items-center text-center group">
              {/* Connecting line (hidden on mobile, visible on lg) */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[calc(50%+32px)] w-[calc(100%-64px)] h-0.5 bg-cv-sky/50" />
              )}

              {/* Number circle */}
              <div className="relative z-10 w-16 h-16 rounded-2xl bg-cv-navy flex items-center justify-center shadow-lg shadow-cv-navy/20 mb-5 group-hover:scale-110 transition-transform">
                <step.icon className="w-7 h-7 text-white" />
              </div>

              {/* Step number */}
              <span className="text-xs font-bold text-cv-navy uppercase tracking-widest mb-2">Step {step.number}</span>

              <h3 className="text-base font-bold text-cv-navy mb-2">{step.title}</h3>
              <p className="text-sm text-cv-navy/70 leading-relaxed">{step.description}</p>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
